import { compose } from 'recompose'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { setRefiDetailsIndex } from 'src/actions/refinance'
import {
  selectRefiDetailsIndex,
  selectRefiDetailsType,
  selectRefiDetailsTerm,
  selectRefiDetailsYears,
  selectRefiDetailsRate,
  selectRefiDetailsAPR,
  selectRefiDetailsLongTerm,
  selectRefiDetailsShortTerm,
  selectRefiDetailsClosing,
  selectRefiDetailsBreakeven,
  selectRefiDetailsDatapoints,
  selectRefiDetailsPotential30Year,
  selectRefiYearsInHome,
  selectPotentialPMISavings
} from 'src/store/selectors/refinance'
import {
  selectCustomerFirstName,
  selectCustomerHasSponsor
} from 'src/store/selectors/customerProfile'
import {
  selectContactFirstName,
  selectContactPhone
} from 'src/store/selectors/contact'

const RefiDetailsModalContainer = compose(
  connect(
    state => ({
      index: selectRefiDetailsIndex(state),
      type: selectRefiDetailsType(state),
      term: selectRefiDetailsTerm(state),
      years: selectRefiDetailsYears(state),
      rate: selectRefiDetailsRate(state),
      apr: selectRefiDetailsAPR(state),
      longterm: selectRefiDetailsLongTerm(state),
      shortterm: selectRefiDetailsShortTerm(state),
      pmi: selectPotentialPMISavings(state),
      closing: selectRefiDetailsClosing(state),
      breakeven: selectRefiDetailsBreakeven(state),
      data: selectRefiDetailsDatapoints(state),
      potential30Year: selectRefiDetailsPotential30Year(state),
      yearsInHome: selectRefiYearsInHome(state),
      hasSponsor: selectCustomerHasSponsor(state),
      customerFirstName: selectCustomerFirstName(state),
      contactFirstName: selectContactFirstName(state),
      contactPhone: selectContactPhone(state)
    }),
    dispatch => ({
      setRefiIndex: index => dispatch(setRefiDetailsIndex(index))
    })
  ),
  injectIntl
)

export default RefiDetailsModalContainer
